<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="Id"
      :rows-per-page-items="rows_per_page"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.DispatchDate | formatDateISO }}</td>
          <td>{{ props.item.TrackNo }}</td>
          <td>{{ props.item.PId }}</td>
          <td>{{ props.item.DocName }}</td>
          <td>{{ props.item.DocMobile }}</td>
          <td style="text-align: center">
            <v-btn
              class="iconBtnStyle"
              fab
              outline
              @click="showItem(props.item)"
            >
              <v-icon class="iconStyle grey--text text--darken-1"
                >fa fa-info</v-icon
              >
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog scrollable persistent max-width="400px" v-model="dlgShow">
      <v-card>
        <v-card-title>
          <div class="title font-weight-medium">
            Dispatch Info
          </div>
        </v-card-title>
        <v-card-text>
          <div class="bor">
            <div>
              <div class="font-weight-medium">Dispatch Date:</div>
              {{ dlgModel.DispatchDate | formatDate }}
            </div>
            <hr class="hrStyle" />
            <div>
              <div class="font-weight-medium">Tracking No.:</div>
              {{ dlgModel.TrackNo }}
            </div>
            <hr class="hrStyle" />
            <div>
              <div class="font-weight-medium">Note:</div>
              {{ dlgModel.Note }}
            </div>
            <hr class="hrStyle" />
            <div>
              <div class="font-weight-medium">Patient Id:</div>
              {{ dlgModel.PId }}
            </div>
            <hr class="hrStyle" />
            <div>
              <div class="font-weight-medium">Patient Name:</div>
              {{ dlgModel.PName }}
            </div>
            <hr class="hrStyle" />
            <div>
              <div class="font-weight-medium">Patient Mobile:</div>
              {{ dlgModel.PMobile }}
            </div>
            <hr class="hrStyle" />
            <div>
              <div class="font-weight-medium">Doctor Name:</div>
              {{ dlgModel.DocName }}
            </div>
            <hr class="hrStyle" />
            <div>
              <div class="font-weight-medium">Doctor Mobile:</div>
              {{ dlgModel.DocMobile }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dlgShow = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["items"],
  data() {
    return {
      rows_per_page: [25, 50],
      headers: [
        {
          text: "Dispatch Date",
          value: "DispatchDate",
          sortable: true,
          width: "10%"
        },
        {
          text: "Tracking No.",
          value: "TrackNo",
          sortable: true,
          width: "10%"
        },
        { text: "Patient Id", value: "PId", sortable: true, width: "10%" },
        { text: "Doctor Name", value: "DocName", sortable: true, width: "10%" },
        {
          text: "Doctor Mobile",
          value: "DocMobile",
          sortable: true,
          width: "10%"
        },
        {
          text: "Actions",
          value: "",
          sortable: false,
          width: "5%",
          align: "center"
        }
      ],
      dlgShow: false,
      dlgModel: {}
    };
  },
  methods: {
    showItem(item) {
      this.dlgModel = {
        DispatchDate: item.DispatchDate,
        TrackNo: item.TrackNo,
        Note: item.Note,
        PId: item.PId,
        PName: item.PName,
        PMobile: item.PMobile,
        DocName: item.DocName,
        DocMobile: item.DocMobile
      };
      this.dlgShow = true;
    }
  }
};
</script>

<style scoped>
.bor {
  border: solid grey 1px;
  padding: 1%;
}
.hrStyle {
  color: #ffffff;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
